import { Button } from "@/components/ui/button";
import { AlertCircle, Download, FileDown } from "lucide-react";

export default function BulkTaxonomyFooter({ rowCount, summary, onScrollToError, onDownload }) {
  return (
    <div className="px-2 pt-2 -mx-6 text-xs flex items-center justify-between flex-wrap gap-2">
      <div className="text-slate-600">
        <b>{rowCount}</b> rows
        {summary && (
          <>
            {" · "}<span className="text-emerald-600 font-semibold">{summary.will_create.issue} create</span>
            {" · "}<span className="text-blue-600 font-semibold">{summary.will_update.issue} update</span>
            {" · "}<span className="text-slate-500 font-semibold">{summary.will_skip} skip</span>
            {summary.rows_invalid > 0 && (
              <>
                {" · "}
                <button type="button" onClick={onScrollToError}
                        className="text-rose-600 font-semibold inline-flex items-center gap-1 hover:underline cursor-pointer"
                        data-testid="taxonomy-jump-errors">
                  <AlertCircle className="w-3 h-3" /> {summary.rows_invalid} error{summary.rows_invalid === 1 ? "" : "s"}
                </button>
              </>
            )}
          </>
        )}
      </div>
      <Button size="sm" variant="ghost" onClick={onDownload} data-testid="download-csv-btn">
        <Download className="w-3.5 h-3.5 mr-1.5" /> <FileDown className="hidden" /> Download current as CSV
      </Button>
    </div>
  );
}
